import React from 'react';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Typography } from '@mui/material';

import PersonAddIcon from '../../../../assets/icons/PersonAddIcon';
import { FEED_BACK } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

const EmptyEmployeeRosterCard = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      background: 'white',
      height: '72px',
      padding: '0 24px',
      borderRadius: '12px',
      border: `2px dashed ${FEED_BACK.GREEN_70}`,
    }}
  >
    <Box display="flex" alignItems="center">
      <PersonAddIcon color={FEED_BACK.GREEN_70} size={24} />
      <Typography
        sx={{
          marginLeft: '10px',
          fontFamily: PRIMARY_FONT[400],
          fontSize: '16px',
          color: FEED_BACK.GREEN_70,
        }}
      >
        {LanguageConverterV2('jobOrder.roster.rosterSpotNeeded')}
      </Typography>
    </Box>
  </Box>
);

export default EmptyEmployeeRosterCard;
